var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4949_73947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.99983V29.9998C4 31.1061 3.10625 31.9998 2 31.9998C0.89375 31.9998 0 31.1061 0 29.9998V1.99983C0 0.893575 0.89375 -0.000174753 2 -0.000174753C3.10625 -0.000174753 4 0.893575 4 1.99983ZM6.55 20.9248C6.3625 20.9811 6.175 21.0311 6 21.0873V0.843575C7.59375 0.399825 9.5625 -0.000174753 11.5 -0.000174753C13.7812 -0.000174753 15.7688 0.568575 17.475 1.05608L17.5562 1.08108C19.3375 1.58733 20.8312 1.99983 22.5 1.99983C24.175 1.99983 25.8062 1.57483 27.0625 1.11858C27.6812 0.893575 28.1812 0.668575 28.525 0.506075C28.6938 0.424825 28.825 0.356075 28.9125 0.312325C28.9563 0.287325 28.9813 0.274825 29 0.262325L29.0125 0.256075C29.6313 -0.0939248 30.3938 -0.0939248 31.0063 0.268575C31.6187 0.631075 32 1.28733 32 1.99983V17.9998C32 18.7561 31.575 19.4498 30.8937 19.7873L30 17.9998C30.8937 19.7873 30.8937 19.7873 30.8937 19.7873H30.8875L30.875 19.7936L30.8312 19.8186C30.7937 19.8373 30.7375 19.8623 30.675 19.8936C30.5375 19.9561 30.35 20.0436 30.1125 20.1436C29.6312 20.3498 28.9562 20.6186 28.1437 20.8873C26.5312 21.4311 24.3 21.9998 22 21.9998C19.6875 21.9998 17.925 21.4123 16.4375 20.9186L16.375 20.8998C14.875 20.3998 13.6438 19.9998 12 19.9998C10.2812 19.9998 8.24375 20.4373 6.55 20.9248Z",
    fill: "#3F69FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4949_73947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.427aec6a1a8305bda2f6a3a220eb3437.svg";
export { ForwardRef as ReactComponent };